// Sürücü Puantajı — bugün + önümüzdeki 7 gün ajandası.
// Matris görünümü: satır = sürücü, sütun = gün. Hücrede servis sayısı + tip renkleri.
// Hücre üzerine gelince servis adları/saatleri görünür (title). Sürücüye tıklayınca detay açılır.

import React, { useMemo } from "react";

import { KIND_META, shortDate, weekdayName } from "../utils";

const UpcomingAgenda = ({ rows = [], onSelectDriver, t }) => {
  // Sadece önümüzdeki 7 günde işi olan sürücüler
  const driversWithWork = useMemo(
    () => rows.filter((r) => (r.upcoming || []).some((d) => d.count > 0)),
    [rows],
  );

  const days = rows[0]?.upcoming || [];

  if (days.length === 0) {
    return <div className="dp-agenda__empty">{t("driverPerformance.noUpcoming")}</div>;
  }

  return (
    <div className="dp-agenda">
      <div className="dp-agenda__scroll">
        <table className="dp-agenda__table">
          <thead>
            <tr>
              <th className="dp-agenda__corner">{t("driverPerformance.table.driver")}</th>
              {days.map((d) => (
                <th key={d.date} className={`dp-agenda__day${d.isWeekday ? "" : " dp-agenda__day--weekend"}`}>
                  <span className="dp-agenda__dayname">{weekdayName(d.date)}</span>
                  <span className="dp-agenda__daydate">{shortDate(d.date)}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {driversWithWork.map((row) => (
              <tr key={row.driver.id} className="dp-agenda__row">
                <td className="dp-agenda__driver" onClick={() => onSelectDriver?.(row.driver)} title={t("driverPerformance.table.openDetail")}>
                  {row.driver.name || "-"}
                </td>
                {row.upcoming.map((day) => (
                  <AgendaCell key={day.date} day={day} t={t} />
                ))}
              </tr>
            ))}
            {driversWithWork.length === 0 && (
              <tr>
                <td colSpan={days.length + 1} className="dp-agenda__empty">
                  {t("driverPerformance.noUpcoming")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const AgendaCell = ({ day, t }) => {
  if (!day.count) return <td className="dp-agenda__cell dp-agenda__cell--empty" />;

  const tooltip = day.services
    .map((s) => `${s.startTime || "--:--"} ${s.name}${s.schoolName ? ` (${s.schoolName})` : ""}`)
    .join("\n");

  // Tipe göre renkli noktalar (en fazla ilk 6)
  const dots = day.services.slice(0, 6);

  return (
    <td className="dp-agenda__cell" title={tooltip}>
      <span className="dp-agenda__count">{day.count}</span>
      <span className="dp-agenda__dots">
        {dots.map((s, i) => {
          const meta = KIND_META[s.kind];
          return (
            <span
              key={`${s.serviceId}-${i}`}
              className="dp-agenda__dot"
              style={{ backgroundColor: meta?.bg || "#bbb", borderColor: meta?.border || "#999" }}
            />
          );
        })}
      </span>
    </td>
  );
};

export default UpcomingAgenda;
